<div
  class="flex cursor-pointer items-center gap-1 rounded-md bg-red-500 py-px pl-1 pr-3 text-sm text-white"
  matRipple
>
  <mat-icon>local_hospital</mat-icon>
  <span>{{ alertCount }} Medical Alerts</span>
</div>
